<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Edit Reason
        </CCardHeader>
        <CCardBody>
          <CForm @submit.prevent="reasoninformationData">
            <CRow>
              <CCol sm="12">
                <CInput
                  label="Reason"
                  placeholder="Enter Reason Name"
                  v-model="reasoninformation.name"
                  type="text"
                />
                <div class="login-errors" v-if="$v.reasoninformation.name.$error">
                  <span class="validation-error" v-if="!$v.reasoninformation.name.required">Please Enter Reason Name</span>
                  <span class="validation-error" v-else-if="!$v.reasoninformation.name.minLength">Too Short</span>
                  <span class="validation-error" v-else-if="!$v.reasoninformation.name.maxLength">Too Long</span>
                </div>
              </CCol>
            </CRow>
              <CRow>
                <CCol col="6" class="text-left">
                  <CButton color="primary" class="px-4 mr-2" type="submit">Edit</CButton>
                  <CButton color="danger" @click="redirectUrls('/reason-list/')" class="px-4" type="button">Cancel</CButton>
                </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
  minLength,
  sameAs
} = require("vuelidate/lib/validators");


export default {
    name: 'EditReason',
    data() {
        return {
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            resources: [],
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            reasoninformation: {
              name: "",
              reasonid: this.$route.params.id
            }
        }
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    components: {
        Loading
    },
    created() {
        document.title = "Edit Reason";
        this.loadData();
    },
    methods: {
      loadData() {
          this.isLoading = true;
          this.showLoader();
          let id = this.$route.params.id
          axios.post(`${API_ADMIN_URL}/adminGetReason/`+id, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
              if (response.data.status == 200) {
                  this.reasoninformation.name = response.data.data.name;
                  this.isLoading = false;
              } else {
                  localStorage.clear();
                  this.$router.push('/login');
              }
            this.hideLoader();
          });
      },
      reasoninformationData: function() {
        // stop here if form is invalid
        this.$v.reasoninformation.$touch();
        if (!this.$v.reasoninformation.$invalid) {
          this.isLoading = true;
          axios.post(`${API_ADMIN_URL}/adminUpdateReason/`, this.reasoninformation, {headers: {'x-access-token': this.tokenChange}}).then(response => {
            if(response.data.status == 200) {
              this.$router.push('/reason-list');
              this.reasoninformation = {
                name: "",
              },
              this.$v.reasoninformation.$reset()
              this.showSuccessMsg({message: response.data.message});
              this.hideLoader();
              this.isLoading = false;
            }
            else {
              this.showErrorMsg({message: response.data.message});
              this.hideLoader();
              this.isLoading = false;
            }
            this.isLoading = false;
          });
        }
      },
      onCancel() {
      },
      showLoader: function() {
        this.$isLoading = true;
        this.$emit('loading', true);
      },
      hideLoader: function() {
        this.$isLoading = false;
        this.$emit('loading', false);
      },
      redirectUrls: function(link) {
          this.$router.push(link);
          // location.href = link;
      }
    },
    mixins: [validationMixin],
    validations: {
      reasoninformation:{
        name: {
                  required,
                  minLength: minLength(2),
                  maxLength: maxLength(50)
              }
      }
    }
}
</script>
